<template>
  <div class="home-page">
    <header-pane
      class="home-page__header"
      colorType="light"
      :pageTitle="$tc('HomePage.pageTitle')"
      :hasHeaderNav="hasHeaderNav"
      navigationCurrent="home"
    />

    <home-pane :enabledCarouselList="true" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import HomePane from '@/components/HomePage/HomePane.vue'

/**
 * HOME ページ
 */
export default defineComponent({
  name: 'HomePage',
  components: {
    HeaderPane,
    HomePane,
  },
  props: {
    /**
     * ヘッダーナビ表示指定
     */
    hasHeaderNav: {
      type: Boolean,
      default: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.home-page {
  background: $gray1;
  min-width: $browserMinWidth;
  min-height: var(--screen-height);
  padding-bottom: 0;
}
</style>

<style lang="scss">
.home-page {
  .home-pane {
    width: 100%;
    height: $mypageContentHeightPC;

    &__pull-down {
      overflow-x: hidden;
    }

    .img-slide-parts {
      &__content {
        padding: 0 min(#{convertPXtoVW(12)}, 12px);
      }
    }

    .countdown-section {
      position: relative;
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: center;
      width: min(100%, 800px);
      padding: 30px 0;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 31.77%, rgba(0, 0, 0, 0.036) 100%),
        linear-gradient(0deg, #f5f4f4, #f5f4f4),
        linear-gradient(
          89.97deg,
          rgba(255, 255, 255, 0) 0.03%,
          #ffffff 52.08%,
          rgba(255, 255, 255, 0) 99.97%
        );
      border: 1px solid #e0e0e0;
      border-radius: 10px;

      &__logo {
        display: block;
      }
    }

    .youtube-list-section {
      max-width: 800px;
      overflow-x: hidden;

      &__title {
        max-width: 100%;
        padding: 0;
      }
    }

    .carousel-list-wrapper-parts {
      &__content {
        padding-left: 0;
      }

      &__list {
        &::after {
          display: none;
        }
      }
    }

    &__highlights-comments {
      max-width: 800px;
      overflow-x: hidden;
    }

    .highlights-scene-section__title {
      max-width: 800px;
      padding-left: 0;
    }

    .sns-content-section__content {
      max-width: 800px;
    }

    .sns-post-item-images-parts {
      max-width: 312px;
      margin-left: auto;
      margin-right: auto;
    }

    .onboarding-circuit-mode-section {
      transition: opacity ease 0.3s;

      &.fade-enter-active,
      &.fade-leave-active {
        opacity: 1;
        pointer-events: auto;
      }

      &.fade-enter,
      &.fade-leave-to {
        opacity: 0;
        pointer-events: none;
      }

      &__mask {
        &--top {
          width: max(100vw, 900px);
        }

        &--bottom {
          width: max(100vw, 900px);
        }

        &--left {
          width: calc(max(50vw, 450px) - 50% - 20px);
        }

        &--right {
          width: calc(max(50vw, 450px) - 50% - 20px);
        }
      }
    }
  }
}
</style>
